export default __webpack_public_path__ + "static/media/enterFullscreen.be77dea7.webp";